import { useEffect, useState } from "react";
import { api, API_BASE } from "@/lib/api";
import { rupiah } from "@/lib/format";
import { PageHeader } from "@/components/app/Layout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Download, FileSpreadsheet } from "lucide-react";

const download = async (path, params, filename) => {
  const token = localStorage.getItem("khn_token");
  const url = new URL(`${API_BASE}${path}`);
  Object.entries(params).forEach(([k,v]) => v && url.searchParams.set(k, v));
  const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` }});
  const blob = await res.blob();
  const a = document.createElement("a"); a.href = URL.createObjectURL(blob); a.download = filename; a.click();
};

export default function LaporanPPh05() {
  const [tahun, setTahun] = useState(new Date().getFullYear());
  const [data, setData] = useState({ total_omzet:0, total_pph:0, rincian: [] });

  const load = async () => {
    const r = await api.get("/laporan/pph-05", { params: { tahun } });
    setData(r.data);
  };
  useEffect(()=>{ load(); }, [tahun]);

  return (
    <>
      <PageHeader title="Tarif Pajak PPh 0,5%" subtitle="Perhitungan pajak final UMKM PP 55/2022." actions={
        <div className="flex gap-2">
          <Button variant="outline" onClick={()=>download("/export/pph-05", {fmt:"pdf", tahun}, `pph-05-${tahun}.pdf`)} className="rounded-sm"><Download size={14} className="mr-1"/> PDF</Button>
          <Button variant="outline" onClick={()=>download("/export/pph-05", {fmt:"xlsx", tahun}, `pph-05-${tahun}.xlsx`)} className="rounded-sm"><FileSpreadsheet size={14} className="mr-1"/> Excel</Button>
        </div>
      }/>
      <div className="p-8 space-y-6">
        <div className="card-flat p-5 max-w-xs">
          <Label>Tahun Pajak</Label>
          <Input type="number" value={tahun} onChange={(e)=>setTahun(Number(e.target.value)||tahun)} data-testid="pph05-tahun"/>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <div className="card-flat p-6" data-testid="card-omzet">
            <div className="text-[11px] uppercase tracking-widest text-slate-500">Total Omzet Kotor</div>
            <div className="mt-3 font-mono text-3xl tabular-nums text-slate-900">{rupiah(data.total_omzet)}</div>
          </div>
          <div className="card-flat p-6" data-testid="card-pph">
            <div className="text-[11px] uppercase tracking-widest text-slate-500">Total PPh 0,5%</div>
            <div className="mt-3 font-mono text-3xl tabular-nums text-emerald-700">{rupiah(data.total_pph)}</div>
          </div>
        </div>
        <div className="card-flat overflow-x-auto">
          <div className="px-5 py-4 border-b border-slate-200 text-sm font-semibold">Rincian Bulanan</div>
          <table className="w-full text-sm">
            <thead><tr className="bg-slate-50 border-b border-slate-200 text-left text-[12px] uppercase tracking-wide text-slate-500">
              <th className="p-3">Bulan</th><th className="p-3 text-right">Omzet Kotor</th><th className="p-3 text-right">PPh 0,5%</th>
            </tr></thead>
            <tbody>
              {data.rincian.length===0 && <tr><td colSpan="3" className="text-center py-10 text-slate-400">Belum ada data untuk tahun ini.</td></tr>}
              {data.rincian.map(r=>(
                <tr key={r.bulan_key} className="border-b border-slate-100">
                  <td className="p-3">{r.bulan}</td>
                  <td className="p-3 text-right font-mono">{rupiah(r.omzet)}</td>
                  <td className="p-3 text-right font-mono font-semibold text-emerald-700">{rupiah(r.pph)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
